import { createSlice, createAsyncThunk } from '@reduxjs/toolkit'

import { parseMessages } from 'helpers/parse-dll-error'
import { prepareData } from 'helpers/prepare-req-data'
import client from 'api'
import _ from 'lodash'

import { v4 as uuid4 } from 'uuid'


const initialState = {
    startProcessr201052Status: 'idle',
    startProcessr201052Error: undefined as any,
    loadUserParamsProcessr201052Status: 'idle',
    loadUserParamsProcessr201052Error: undefined as any,

    processr201052List: [] as any[],
    defaultValues: undefined as any,
    job: undefined as any,
    filterValues: {} as any,
    filterLookupValues: {} as any,

    directLoad: false,
    load: false,
    activeDivRef: null as any,

    filterValuesId: null,
    valuesFromDB: false
}
export const startProcessr201052 = createAsyncThunk('processr201052Slice/startProcessr201052', async (processr201052: any, { rejectWithValue, getState }: any) => {
    const url = `/api/ixweb/StartProcessr201052/`


    const res = await client.post(url, prepareData(processr201052))

    // check type of response -  winrest or backend
    if (typeof(res.data) === 'object' && res.data.hasOwnProperty('status')) {  // winrest response
        if (res.data.status === 'Failed') {
            return rejectWithValue(parseMessages(res.data.messages))
        } else {
            return { job_id: res.data.job_id }
        }
    } else {  // backend response
        return res.data
    }
})
export const loadUserParamsProcessr201052 = createAsyncThunk('processr201052Slice/loadUserParamsProcessr201052', async (_, { rejectWithValue, getState }: any) => {
    const url = `/api/ixweb/LoadUserParamsProcessr201052/`


    const res = await client.get(
        url,
        {
        })

    // check type of response -  winrest or backend
    if (typeof(res.data) === 'object' && res.data.hasOwnProperty('status')) {  // winrest response
        if (res.data.status === 'Failed') {
            return rejectWithValue(parseMessages(res.data.messages))
        } else {
            return res.data.data
        }
    } else {  // backend response
        return res.data
    }
})

const Processr201052Slice = createSlice({
    name: 'processr201052Slice',
    initialState,
    reducers: {
        resetstartProcessr201052: (state) => {
            state.job = undefined
            state.startProcessr201052Error = undefined
        },
        resetstartProcessr201052Error: (state) => {
            state.startProcessr201052Error = undefined
        },
        resetloadUserParamsProcessr201052: (state) => {
            state.defaultValues = undefined
            state.loadUserParamsProcessr201052Error = undefined
        },
        resetloadUserParamsProcessr201052Error: (state) => {
            state.loadUserParamsProcessr201052Error = undefined
        },
        removeFromProcessr201052ListById: (state, action) => {
            state.processr201052List = state.processr201052List.filter((x: any) => x.HDR_ID !== action.payload)
        },
        setFilterValues: (state, action) => {
            if (action.payload === undefined || action.payload === null) {
                state.filterValues = {}
            } else {
                state.filterValues = { ...state.filterValues, ...action.payload }
            }
        },
        setFilterLookupValue: (state, action) => {
            const { name, value, formValue } = action.payload
            if (name) {
                state.filterLookupValues[name] = value
                state.filterValues[name] = formValue
            }
        },
        setDirectLoad: (state, action) => { state.directLoad = action.payload },
        setLoad: (state, action) => { state.load = action.payload },
        setActiveDivRef: (state, action) => { state.activeDivRef = action.payload},
        setFilterValuesId: (state, action) => {
            state.filterValuesId = action.payload
        },
        setValuesFromDB: (state, action) => {
            state.valuesFromDB = action.payload
        },
        preloadData: (state, action) => {
            state.processr201052List = action.payload.map((x: any) => ({ ...x, HDR_ID: uuid4()}))
            state.startProcessr201052Status = 'preloaded'
        },
        clearPreloadedData: (state) => {
            state.processr201052List = []
            state.startProcessr201052Status = 'idle'
        },
    },
    extraReducers: builder => {
        builder.addCase(startProcessr201052.pending, (state) => {
            state.startProcessr201052Status = 'pending'
            state.startProcessr201052Error = undefined
        })
        builder.addCase(startProcessr201052.fulfilled, (state, action) => {
            state.startProcessr201052Status = 'idle'


            state.job = action.payload
        })
        builder.addCase(startProcessr201052.rejected, (state, action) => {
            state.startProcessr201052Status = 'error'
            if (action.error.message !== 'Rejected') {
                state.startProcessr201052Error = action.error.message
            } else {
                state.startProcessr201052Error = action.payload
            }
        })

        builder.addCase(loadUserParamsProcessr201052.pending, (state) => {
            state.loadUserParamsProcessr201052Status = 'pending'
            state.loadUserParamsProcessr201052Error = undefined
        })
        builder.addCase(loadUserParamsProcessr201052.fulfilled, (state, action) => {
            state.loadUserParamsProcessr201052Status = 'idle'


            state.defaultValues = action.payload
        })
        builder.addCase(loadUserParamsProcessr201052.rejected, (state, action) => {
            state.loadUserParamsProcessr201052Status = 'error'
            if (action.error.message !== 'Rejected') {
                state.loadUserParamsProcessr201052Error = action.error.message
            } else {
                state.loadUserParamsProcessr201052Error = action.payload
            }
        })

    }
})

export const {
    resetstartProcessr201052,
    resetstartProcessr201052Error,
    resetloadUserParamsProcessr201052,
    resetloadUserParamsProcessr201052Error,
    removeFromProcessr201052ListById,
    setFilterValues,
    setFilterLookupValue,
    setDirectLoad,
    setLoad,
    setActiveDivRef,
    setFilterValuesId,
    setValuesFromDB,
    preloadData,
    clearPreloadedData,
} = Processr201052Slice.actions
export default Processr201052Slice.reducer
